import { CloseIcon } from '@atbay/icons'
import { clsx } from 'clsx'
import { ChangeEvent } from 'react'

interface Props {
    id: string
    value: string
    className?: string
    removable?: boolean
    onRemove?: () => void
    clickable?: boolean
    onTagEdit?: (tag: { id: string; value: string }) => void
}

const InputTag = ({
    id,
    value,
    removable = true,
    className,
    onRemove,
    clickable = false,
    onTagEdit,
}: Props) => {
    const [editModeOn, setEditModeOn] = useState(false)
    const [editedValue, setEditedValue] = useState(value)
    const onClickHandler = () => {
        setEditModeOn(true)
    }

    const onChange = (e: ChangeEvent<HTMLInputElement>) => {
        setEditedValue(e.target.value)
    }

    const onBlur = (e: ChangeEvent<HTMLInputElement>) => {
        setEditedValue(e.target.value)
        setEditModeOn(false)
        onTagEdit?.({ id, value: e.target.value })
    }

    const onKeyDown = (e: any) => {
        if (e.key === 'Enter') {
            setEditModeOn(false)
            onTagEdit?.({ id, value: e.target.value })
        }
    }

    return (
        <div
            className={clsx(['tag', className])}
            {...(clickable ? { onClick: onClickHandler } : {})}
            data-testid={className}
        >
            <span>
                {!editModeOn ? (
                    value
                ) : (
                    <input
                        type="text"
                        value={editedValue}
                        onKeyDown={onKeyDown}
                        onChange={onChange}
                        onBlur={onBlur}
                        className="edit-tag"
                    />
                )}
            </span>

            {removable && (
                <span
                    className="close-btn"
                    onClick={(e) => {
                        e.stopPropagation()
                        onRemove?.()
                    }}
                >
                    <CloseIcon />
                </span>
            )}
        </div>
    )
}

export default InputTag
